module.exports = __webpack_public_path__ + "img/navbar-user.3a965278.svg";